/* eslint-disable react-hooks/rules-of-hooks */
import React from 'react'

import Menu from '../../../../components/InternalMenu/Menu'

import { useForm } from "react-hook-form"
import { post } from '../../../../services/http'

import { notify } from '../../../../components/Toast'
import { ToastContainer } from 'react-toastify'

import { useNavigate } from 'react-router-dom'

export default function index() {
  const navigate = useNavigate()

  document.title = 'ساخت بنرها'

  const { register, handleSubmit } = useForm()

  const token = localStorage.getItem('token')

  const onSubmit = (data, e) => {
    e.preventDefault()
    console.log(data)
    let banners = [
      { 
        link : data['bannerLink1'],
        pic : data['bannerPic1']
      },
      { 
        link : data['bannerLink2'],
        pic : data['bannerPic2']
      },
      { 
        link : data['bannerLink3'],
        pic : data['bannerPic3']
      },
    ]

    post(`/api/admin/im/banners?token=${token}`, { banners: banners }).then(response => {
        notify('success', response.data.messageFa)
        setTimeout(() => {
          navigate('/im/banners')
        }, 2000)
      }).catch(error => {
        if (error) {
          notify('error', error)
        }
        notify('error', 'خطا در ارسال اطلاعات')
      })
  }

  return (
    <main id='panel'>
      <ToastContainer rtl />
      <Menu page={'banner'} badgeCountDashboard={0} badgeCountOrder={0} />
      <article className='panelBody'>
        <section className='panelContent'>
          <div className='title'>
            <div className='right'>
              <div className='text'>
                جایگاه بنرها
              </div>
            </div>

            <div className='left'>
            </div>
          </div>

          <form className='form' onSubmit={handleSubmit(onSubmit)}>
            <div className='title'>
              * برای ساخت جایگاه بنرها لطفا تمامی فیلد های مشخص شده را پر کنید.
            </div>
            <div className='lineTitle'>
              <hr />
              اطلاعات بنرها
              <hr />
            </div>
            <div className='row'>
              <div className='column'>
                <label htmlFor='offCodeName'>لینک بنر اول * :</label>
                <input id='offCodeName' {...register("bannerLink1", { required: true, minLength: 1 })} className='ltrdirection' type='text' placeholder='https://...' />
                <small id='offCodeNameAlert'>نام کد تخفیف باید وارد شود</small>
              </div>
              <div className='column'>
                <label htmlFor='offCodePercent'>لینک تصویر بنر اول * :</label>
                <input id='offCodePercent' {...register("bannerPic1", { required: true, minLength: 2 })}  className='ltrdirection' type='text' placeholder='https://...' />
                <small id='offCodePercentAlert'>درصد کد تخفیف باید وارد شود</small>
              </div>
            </div>
            <div className='row'>
              <div className='column'>
                <label htmlFor='offCodeName'>لینک بنر دوم * :</label>
                <input id='offCodeName' {...register("bannerLink2", { required: true, minLength: 1 })} className='ltrdirection' type='text' placeholder='https://...' />
                <small id='offCodeNameAlert'>نام کد تخفیف باید وارد شود</small>
              </div>
              <div className='column'>
                <label htmlFor='offCodePercent'>لینک تصویر بنر دوم * :</label>
                <input id='offCodePercent' {...register("bannerPic2", { required: true, minLength: 2 })}  className='ltrdirection' type='text' placeholder='https://...' />
                <small id='offCodePercentAlert'>درصد کد تخفیف باید وارد شود</small>
              </div>
            </div>
            <div className='row'>
              <div className='column'>
                <label htmlFor='offCodeName'>لینک بنر سوم * :</label>
                <input id='offCodeName' {...register("bannerLink3", { required: true, minLength: 1 })} className='ltrdirection' type='text' placeholder='https://...' />
                <small id='offCodeNameAlert'>نام کد تخفیف باید وارد شود</small>
              </div>
              <div className='column'>
                <label htmlFor='offCodePercent'>لینک تصویر بنر سوم * :</label>
                <input id='offCodePercent' {...register("bannerPic3", { required: true, minLength: 2 })}  className='ltrdirection' type='text' placeholder='https://...' />
                <small id='offCodePercentAlert'>درصد کد تخفیف باید وارد شود</small>
              </div>
            </div>
            <button className='createButton'>ثبت</button>
          </form>
          <div className='copyright'>
            © تمامی حقوق برای <a href='https://ibills.ir'>ibills</a> محفوظ است. طراحی و توسعه توسط <a href='https://ham-team.ir'>هم تیم</a>
          </div>
        </section>
      </article>
    </main>
  )
}
